export const UNBREAKABLE_SEPARATOR = '\u00A0';
export const TEXT_DOT_SEPARATOR = ' •\u00A0';
export const TEXT_COMMA_SEPARATOR = ', ';
export const HIDE_DATA_SYMBOL = '*';
